/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { claimbucket } from "./claimbucket";

export class claimbucketindex extends claimbucket {
  claim_bucket_index_key: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_BUCKET_INDEX";
  }
}
